import * as React from "react";
import { connect } from "react-redux";
import { getHeightReferencesNorwegian, heightReferenceFromDomain, heightReferenceNorwegianToDomain, isHeightReferenceRecommended } from "../../../../../heightReferenceUtilities";
import { AttributeType } from "../../../../../integration/datacatalog/datacatalog-services";
import { EditHeightReference, editHeightReference } from "../../../../actions/actions";
import { DisplayFeature, HeightReference } from "../../domain";
import FeaturesState from "../../domain/FeaturesState";
import * as selectors from "../../selectors";
import classNames = require("classnames");

interface CellState {}

interface TagProps {
  hasFocus: boolean;
  feature: DisplayFeature;
  loading: boolean;
  geometryAttributeType: AttributeType;
}

interface DispatchProps {
  editHeightReference: EditHeightReference;
}

interface StateProps {
  showEditor: boolean;
}

type Props = TagProps & StateProps & DispatchProps;

class HeightReferenceCell extends React.Component<Props, CellState> {
  render() {
    let {
      hasFocus,
      feature,
      editHeightReference,
      loading,
      geometryAttributeType
    } = this.props;

    let cellValueClasses = classNames({
      "cell-component": true,
      "cell-focus": hasFocus,
      disabled: feature.isLocked,
    });

    const norwegianHeightReference = heightReferenceFromDomain(
      feature?.geometry?.heightReference as HeightReference
    ) ?? '';

    const editor =
      this.props.hasFocus && this.props.showEditor ? (
        <HeightReferenceEditor
          feature={feature}
          editHeightReference={editHeightReference}
          geometryAttributeType={geometryAttributeType}
        />
      ) : null;

    if (loading) {
      return <div className={"cssloader small"} />;
    }

    return (
        <div className={cellValueClasses}>
            {editor || (
                `${norwegianHeightReference}${
                    isHeightReferenceRecommended(
                        feature?.geometry?.heightReference as HeightReference,
                        geometryAttributeType
                    )
                        ? ' (anbefalt)'
                        : ''
                }`
            )}
        </div>
    );
  }
}

const mapStateToProps = (state: FeaturesState): StateProps => {
  return {
    showEditor: selectors.showEditor(state),
  };
};

const mapDispatchToProps: DispatchProps = {
  editHeightReference: editHeightReference,
};

export default connect(mapStateToProps, mapDispatchToProps)(HeightReferenceCell);

interface DropDownEditorProps {
  editHeightReference: EditHeightReference;
  feature: DisplayFeature;
  geometryAttributeType: AttributeType;
}

interface DropDownEditorState {
  options: string[];
}

class HeightReferenceEditor extends React.Component<
  DropDownEditorProps,
  DropDownEditorState
> {
  private inputElement: HTMLSelectElement;

  constructor(props: DropDownEditorProps) {
    super(props);
    this.state = { options: getHeightReferencesNorwegian() };
  }

  render() {
    let { feature, geometryAttributeType } = this.props;

    return (
      <span>
        <select
          value={heightReferenceFromDomain(
            feature?.geometry?.heightReference as HeightReference
          )}
          onChange={(e) => this.handleValueChange(e)}
          ref={(elm) => (this.inputElement = elm)}
        >
          <option key={"novalue"} value={null}>
            (Ingen verdi)
          </option>
          {this.state.options.map((option) => (
            <option key={option} value={option}>
              {option}{" "}
              {isHeightReferenceRecommended(
                heightReferenceNorwegianToDomain(option),
                geometryAttributeType
              ) && " (anbefalt)"}
            </option>
          ))}
        </select>
      </span>
    );
  }

  componentDidMount(): void {
    this.inputElement.focus();
  }

  handleValueChange = function (event: React.ChangeEvent<HTMLSelectElement>) {
    let { feature, editHeightReference } = this.props;
  
    editHeightReference(
      feature.id,
      heightReferenceNorwegianToDomain(event.target.value),
    );
  };
}
